import {createContext, useContext} from 'react'

import {useGetUserDetails, useLogin, useLogout} from '@no-auth/service/noauth.data'

import type {User} from '@app-types/api'

export interface IUserContextValue {
  user: User | undefined
  isUserDetailsLoading: boolean
  isAuthenticated: boolean
  isLoginError: boolean
  login: (credentials: {username: string; password: string}) => Promise<void>
  logout: () => Promise<void>
}

const UserContext = createContext<IUserContextValue | undefined>(undefined)

export const UserProvider = ({children}: {children: React.ReactNode}) => {
  const {data: user, isPending, isError} = useGetUserDetails()
  const {mutateAsync: doLogin, isError: isLoginError} = useLogin()
  const {mutateAsync: doLogout} = useLogout()

  const value: IUserContextValue = {
    user,
    isUserDetailsLoading: isPending && !isError,
    isAuthenticated: !!user,
    isLoginError,
    login: async credentials => {
      await doLogin(credentials)
    },
    logout: async () => {
      await doLogout()
      window.location.assign('/login')
    },
  }
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}

export const useUser = () => {
  const ctx = useContext(UserContext)
  if (!ctx) throw new Error('useUser must be used within UserProvider')
  return ctx
}
